import Button from 'common/components/Button';
import Heading from 'common/components/Heading';
import Link from 'common/components/Link';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import {
  PiArrowRight,
  PiFlag,
  PiLockKey,
  PiUserMinus,
} from 'react-icons/pi';
import Fade from 'react-reveal/Fade';
import Section, {
  CommunityPanel,
  Content,
  FeatureCard,
  FeatureGrid,
  Grid,
  SectionHeading,
} from './technology.style';

const safetyIcons = {
  block: PiUserMinus,
  privacy: PiLockKey,
  report: PiFlag,
};

const Technology = (props) => {
  const data = useStaticQuery(graphql`
    query {
      appJson {
        technologyCommunity {
          button {
            label
            link
          }
          desc
          features {
            content
            iconName
            id
            title
          }
          slogan
          title
        }
      }
    }
  `);
  const technology = data?.appJson?.technologyCommunity;

  return (
    <Section {...props}>
      <Container width="1400px">
        <Grid>
          <Content>
            <SectionHeading>
              <Text className="subtitle" content={technology?.slogan} />
              <Heading content={technology?.title} />
              <Text className="description" content={technology?.desc} />
              <Link
                to={technology?.button?.link}
                className="explore"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  title={technology?.button?.label}
                  icon={<PiArrowRight aria-hidden="true" />}
                />
              </Link>
            </SectionHeading>
          </Content>
          <CommunityPanel aria-label="Furbuz community safety features">
            <Fade up>
              <FeatureGrid>
                {technology?.features?.map((feature) => {
                  const SafetyIcon = safetyIcons[feature?.iconName] || PiLockKey;
                  return (
                    <FeatureCard key={feature?.id}>
                      <span aria-hidden="true">
                        <SafetyIcon />
                      </span>
                      <div>
                        <Heading as="h3" content={feature?.title} />
                        <Text content={feature?.content} />
                      </div>
                    </FeatureCard>
                  );
                })}
              </FeatureGrid>
            </Fade>
          </CommunityPanel>
        </Grid>
      </Container>
    </Section>
  );
};

export default Technology;
